import React from 'react';
import apple from '../assets/brandsSlide/apple.png';
import mi from '../assets/brandsSlide/mi.png';
import nokia from '../assets/brandsSlide/nokia.png';
import oneplus from '../assets/brandsSlide/oneplus.png';
import oppo from '../assets/brandsSlide/oppo.png';
import realme from '../assets/brandsSlide/realme.png';
import samsung from '../assets/brandsSlide/samsung.png';
import vivo from '../assets/brandsSlide/vivo.png';

const Slidebar = () => {
    const images = [
        vivo,
        samsung,
        apple,
        realme,
        oppo,
        mi,
        nokia,
        oneplus,
    ];

    const duplicatedImages = [...images, ...images, ...images];

    return (
        <div className="slider-container w-full">
            <div className="slider w-full bg-[#42C8B7] overflow-x-hidden py-2 sm:py-">
                <div
                    className="slide-track flex items-center"
                    style={{
                        width: 'calc(80px * 24)',
                        animation: 'scroll 30s linear infinite'
                    }}
                >
                    {duplicatedImages.map((img, index) => (
                        <div 
                            key={index} 
                            className="slide flex-shrink-0 px-2 xs:px-3 sm:px-4"
                        >
                            <img
                                src={img}
                                alt={`Brand logo ${index + 1}`}
                                className="h-6 xs:h-7 sm:h-8 md:h-9 object-contain filter brightness-0 invert opacity-90 hover:opacity-100 transition-opacity duration-200"
                            />
                        </div>
                    ))}
                </div>
            </div>

            <style jsx>{`
                @keyframes scroll {
                    0% {
                        transform: translateX(0);
                    }     
                    100% {
                        transform: translateX(calc(-80px * 8));
                    }
                }

                /* Responsive animations */
                @media (min-width: 375px) {
                    .slide-track {
                        width: calc(90px * 24) !important;
                        animation: scroll 35s linear infinite !important;
                    }
                    @keyframes scroll {
                        0% { transform: translateX(0); }
                        100% { transform: translateX(calc(-90px * 8)); }
                    }
                }

                @media (min-width: 640px) {
                    .slide-track {
                        width: calc(120px * 24) !important;
                        animation: scroll 40s linear infinite !important;
                    }
                    @keyframes scroll {
                        0% { transform: translateX(0); }
                        100% { transform: translateX(calc(-120px * 8)); }
                    }
                }

                @media (min-width: 768px) {
                    .slide-track {
                        width: calc(140px * 24) !important;
                        animation: scroll 45s linear infinite !important;
                    }
                    @keyframes scroll {
                        0% { transform: translateX(0); }
                        100% { transform: translateX(calc(-140px * 8)); }
                    }
                }

                @media (min-width: 1024px) {
                    .slide-track {
                        width: calc(160px * 24) !important;
                        animation: scroll 50s linear infinite !important;
                    }
                    @keyframes scroll {
                        0% { transform: translateX(0); }
                        100% { transform: translateX(calc(-160px * 8)); }
                    }
                }
                }
            `}</style>
        </div>
    );
};

export default Slidebar;